// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import TerceraTabContainerTemplate from '@front/templates/TerceraTabContainerTemplate.html';
import { ContainerControl } from './ContainerControl';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraTabContainer extends ContainerControl {
    constructor() {
        super(...arguments);
        this.onTabChange = null;
        this.onCBItemClickEvent = null;
    }
    getType() {
        return 'TerceraTabContainer';
    }
    oninit() {
        super.oninit();
        this.on('tabStripItem', this.tabStripItemChange);
        this.on('onComboItemClicked', this.onComboItemClicked);
        this.onTabChange = new CustomEvent();
        this.onCBItemClickEvent = new CustomEvent();
    }
    oncomplete() {
        super.oncomplete();
        this.populateTabStrip();
        const items = this.get('items');
        if (isValidArray(items)) {
            items[0].selected = true;
            void this.set({
                items,
                selectedItem: items[0]
            });
        }
    }
    populateTabStrip() {
        const tabs = this.get('tabHeaderKeys');
        const items = [];
        if (!isValidArray(tabs)) {
            return;
        }
        for (let i = 0; i < tabs.length; i++) {
            const item = { type: NewContextMenuItemType.Default, text: tabs[i], value: tabs[i] };
            items.push(item);
        }
        void this.set('items', items);
    }
    tabStripItemChange(event, index) {
        const items = this.get('items');
        const selectedItem = this.get('selectedItem');
        const newSelectedItem = items[index];
        if (newSelectedItem === selectedItem) {
            return;
        }
        if (!isNullOrUndefined(selectedItem)) {
            selectedItem.selected = false;
        }
        newSelectedItem.selected = true;
        void this.set({
            items,
            selectedItem: newSelectedItem
        });
        this.onTabChange.Raise(newSelectedItem.value);
    }
    // TODO: Need to check order of parameters
    onComboItemClicked(context, dataType, selectedItem) {
        void this.set('selectedCBItem', selectedItem);
        this.onCBItemClickEvent.Raise(selectedItem);
    }
}
ContainerControl.extendWith(TerceraTabContainer, {
    template: TerceraTabContainerTemplate,
    data: function () {
        return {
            tabWidth: 20,
            items: [],
            selectedItem: null,
            selectedCBItem: null,
            cbItems: [],
            tabHeaderKeys: null
        };
    }
});
